import { render, staticRenderFns } from "./TicketsBeginnersLinksManagement.vue?vue&type=template&id=1ef2fe95&scoped=true&"
import script from "./TicketsBeginnersLinksManagement.vue?vue&type=script&lang=js&"
export * from "./TicketsBeginnersLinksManagement.vue?vue&type=script&lang=js&"
import style0 from "./TicketsBeginnersLinksManagement.vue?vue&type=style&index=0&id=1ef2fe95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2fe95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VRow,VSpacer,VTextField})
